export default __webpack_public_path__ + "static/hero-964827f3be23e27cb2ff74f6e6149d01.mp4";